import styled from "styled-components";

export const PageHeaderRoot = styled.header`
  display: flex;
  flex-direction: column;
  width: 100%;
  flex-shrink: 0;
  margin-bottom: 1rem;
  gap: 0.75rem;
`;

export const HeaderTop = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 1rem;
  width: 100%;
  min-height: 48px;
`;

export const HeaderTitle = styled.h1`
  margin: 0;
  padding: 0;
  font-size: 2rem;
  font-weight: 700;
  line-height: 1.2;
  background: linear-gradient(135deg, var(--accent-secondary) 0%, var(--accent) 100%);
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
  background-clip: text;
  text-shadow: 0 4px 20px var(--accent-secondary-soft);

  @media (max-width: 768px) {
    font-size: 1.65rem;
  }
`;

export const HeaderActions = styled.div`
  display: flex;
  align-items: center;
  justify-content: flex-end;
  gap: 0.75rem;
  flex-shrink: 0;
  margin-left: auto;
`;

export const HeaderActionButton = styled.button`
  background: var(--accent-secondary-soft);
  border: 2px solid var(--border-default);
  border-radius: 16px;
  color: var(--text-heading);
  cursor: pointer;
  padding: 10px 20px;
  text-align: center;
  transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
  font-size: 14px;
  font-weight: 500;
  backdrop-filter: blur(10px);
  position: relative;
  overflow: hidden;
  min-height: 42px;
  white-space: nowrap;

  &::before {
    content: "";
    position: absolute;
    inset: 0;
    background: linear-gradient(
      135deg,
      var(--accent-secondary-soft) 0%,
      var(--accent-soft) 100%
    );
    opacity: 0;
    transition: opacity 0.3s ease;
    border-radius: 14px;
    z-index: -1;
  }

  &:hover {
    transform: translateY(-2px);
    border-color: var(--accent);
    color: var(--text-primary);

    &::before {
      opacity: 1;
    }
  }

  &:active {
    transform: translateY(-1px);
  }

  &:disabled {
    opacity: 0.6;
    cursor: not-allowed;
    transform: none;
  }

  @media screen and (max-width: 768px) {
    padding: 8px 16px;
    min-height: 38px;
  }
`;

/** Sempre ocupa a mesma altura — com ou sem abas — para alinhar a busca. */
export const TabsNav = styled.nav`
  display: flex;
  align-items: flex-end;
  gap: 0;
  width: 100%;
  min-height: 2.4rem;
  border-bottom: 1px solid var(--border-default);
`;

export const Tab = styled.button`
  appearance: none;
  background: transparent;
  border: none;
  border-bottom: 2px solid transparent;
  margin-bottom: -1px;
  border-radius: 0;
  padding: 0.55rem 0.85rem;
  padding-left: ${({ $first }) => ($first ? "0" : "0.85rem")};
  font-size: 0.92rem;
  font-weight: ${({ $active }) => ($active ? 600 : 500)};
  color: ${({ $active }) =>
    $active ? "var(--accent-secondary)" : "var(--text-secondary)"};
  border-bottom-color: ${({ $active }) =>
    $active ? "var(--accent)" : "transparent"};
  cursor: pointer;
  transition: color 0.15s ease, border-color 0.15s ease;
  white-space: nowrap;

  &:hover {
    color: var(--text-heading);
  }

  &:focus-visible {
    outline: 2px solid var(--accent);
    outline-offset: 2px;
  }
`;

export const SearchBar = styled.div`
  display: flex;
  align-items: stretch;
  width: 100%;
  min-height: 48px;
  border-radius: 16px;
  overflow: hidden;
  background: var(--input-bg);
  border: 1px solid var(--border-subtle);
  box-shadow: var(--shadow-sm);
  backdrop-filter: blur(20px);
  transition: border-color 0.2s ease, box-shadow 0.2s ease;
  box-sizing: border-box;

  &:hover,
  &:focus-within {
    border-color: var(--accent);
    box-shadow: var(--shadow-md);
  }
`;

export const SearchSelect = styled.select`
  flex: 0 0 auto;
  min-width: 180px;
  max-width: 42%;
  padding: 0.7rem 2.2rem 0.7rem 1rem;
  border: none;
  border-right: 1px solid var(--border-subtle);
  background-color: transparent;
  color: var(--accent-secondary);
  font-size: 14px;
  outline: none;
  cursor: pointer;
  appearance: none;
  background-image:
    linear-gradient(45deg, transparent 50%, var(--text-heading) 50%),
    linear-gradient(135deg, var(--text-heading) 50%, transparent 50%);
  background-repeat: no-repeat;
  background-position:
    calc(100% - 16px) calc(50% - 2px),
    calc(100% - 11px) calc(50% - 2px);
  background-size: 5px 5px, 5px 5px;

  option {
    background: var(--surface-overlay);
    color: var(--accent-secondary);
  }

  @media (max-width: 768px) {
    min-width: 140px;
    max-width: 48%;
    font-size: 13px;
  }
`;

export const SearchInput = styled.input`
  flex: 1 1 auto;
  min-width: 0;
  padding: 0.7rem 1rem;
  border: none;
  outline: none;
  background: transparent;
  font-size: 14px;
  color: var(--text-primary);

  &::placeholder {
    color: var(--text-secondary);
    opacity: 1;
  }

  &:focus::placeholder {
    opacity: 0.6;
  }

  @media (max-width: 768px) {
    font-size: 13px;
  }
`;
